import axios from 'axios';
import { AppResponse } from '../models/Response';
import { Util } from '../Util';

export class PurchaseOrderService {
  //get invoice data for public route
  public static async getPurchaseOrderDisplayData(
    purchaseOrderId: any
  ): Promise<AppResponse<any>> {
    const url = Util.apiPublicUrl(`purchaseOrder-link-data/${purchaseOrderId}`);

    const res = await axios.get<void, AppResponse<any>>(url);

    return res;
  }

  // public static async sendInvoiceData(
  //   invoiceId: string,
  //   phoneNumber: string
  // ): Promise<AppResponse<any>> {
  //   const url = Util.apiPublicUrl(`save-invoice-by-phone-number`);

  //   const res = await axios.post<void, AppResponse<any>>(url, {
  //     invoiceId,
  //     phoneNumber
  //   });

  //   return res;
  // }
}
